import React from 'react';
import { PUBLIC_DOMAIN } from '@constants';
import { ImageType } from '@types';
import Image from '@components/Image';
import addNewSandTable from '../actions/addNewSandTable';

function SandTableEmpty() {
  return (
    <div
      className="mt-15 flex flex-1 flex-col items-center justify-center"
      style={{
        backgroundImage: `url(${PUBLIC_DOMAIN}/imgs/map-bg.e447fc917f7fe1203fbb59911e6f7e01.png)`,
        backgroundPosition: 'center',
      }}
    >
      <div
        className="flex h-150 w-150 cursor-pointer flex-col items-center justify-center rounded bg-blue hover:bg-blue-active"
        onClick={addNewSandTable}
      >
        <Image
          src="/imgs/craete-map.bf44759f8f4d2fc092f96457c9c67af6.png"
          type={ImageType.sysMedia}
          style={{ width: 68, height: 65 }}
        />
        <div className="mt-10 text-xl">创建沙盘</div>
      </div>
      {/* <div */}
      {/*  className="mt-30 text-black-gray hover:text-white cursor-pointer" */}
      {/*  onClick={() => { */}
      {/*  }} */}
      {/* > */}
      {/*  沙盘是什么？ */}
      {/* </div> */}
    </div>
  );
}

export default SandTableEmpty;
